import React, { useState } from 'react';
import CryptoJS from 'crypto-js';
import * as bip39 from 'bip39';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

const VerifyDoc = () => {
  const [hash, setHash] = useState('');
  const [mnemonic, setMnemonic] = useState('');
  const [pdfFileName, setPdfFileName] = useState('');
  const [error, setError] = useState('');
  const [copySuccess, setCopySuccess] = useState('');

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const arrayBuffer = e.target.result;
        const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
        const sha256Hash = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
        setHash(sha256Hash);
        setPdfFileName(file.name);
        setCopySuccess('');
        setError('');

        try {
          const binaryHash = BigInt(`0x${sha256Hash}`).toString(2).padStart(256, '0');
          const first66Bits = binaryHash.slice(0, 66);
          const words = [];

          for (let i = 0; i < 6; i++) {
            const chunk = first66Bits.slice(i * 11, (i + 1) * 11);
            const index = parseInt(chunk, 2);
            words.push(bip39.wordlists.english[index]);
          }

          const mnemonicPhrase = words.join(' ');
          setMnemonic(mnemonicPhrase);
        } catch (error) {
          setError('Error generating mnemonic.');
        }
      };
      reader.onerror = () => setError('Error reading file');
      reader.readAsArrayBuffer(file);
    } else {
      setError('Please upload a valid PDF file');
      setHash('');
      setMnemonic('');
    }
  };

  const handleCopyCombined = () => {
    if (hash && mnemonic && pdfFileName) {
      const combined = `SHA-256 Hash: ${hash} | Mnemonic: ${mnemonic} | File Name: ${pdfFileName}`;
      navigator.clipboard?.writeText(combined)
        .then(() => setCopySuccess('Combined hash, mnemonic, and file name copied!'))
        .catch(() => setCopySuccess('Failed to copy.'));
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <img className="logo" src={logo} alt="Main Logo" />
      <h2>Upload PDF, Generate Hash, and Mnemonic</h2>
      <input type="file" accept="application/pdf" onChange={handleFileChange} />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {hash && (
        <div>
          <h3>Your SHA-256 Hash:</h3>
          <p>{hash}</p>
        </div>
      )}
      {mnemonic && (
        <div>
          <h3>Mnemonic Phrase:</h3>
          <p>{mnemonic}</p>
        </div>
      )}
      {hash && mnemonic && (
        <div style={{ marginTop: '20px' }}>
          <h3>Combined Hash, Mnemonic, and File Name:</h3>
          <p>{`SHA-256 Hash: ${hash} | Mnemonic: ${mnemonic} | File Name: ${pdfFileName}`}</p>
          <button
            onClick={handleCopyCombined}
            style={{
              backgroundColor: 'red',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Please Copy Your Hash
          </button>
          {copySuccess && <p style={{ color: 'green' }}>{copySuccess}</p>}
        </div>
      )}
      <br /><br />
      <div>Powered by</div>
      <img className='logo2' src={logo2} alt="Logo 2" />
      <div>New Wave Consulting Group</div>
    </div>
  );
};

export default VerifyDoc;
